import styled from "@emotion/styled";
import {observer} from "mobx-react";
import React from "react";

import {PopoverButton} from "../../molecules/popover-button/popover-button";
import {TagAddForm} from "./tag-add-form";
import {TagAddStore} from "./tag-add-store";

const TagAddButtonContentDiv = styled.div`
    padding: 10px;
    width: 300px;
`;

interface TagAddButtonProps {
    store: TagAddStore;
    onCreated?: () => Promise<unknown>;
}

export const TagAddButton: React.FC<TagAddButtonProps> = observer((props) => {
    return (
        <PopoverButton
            label="タグ作成"
            isLoading={props.store.isCreating}
            isOpen={props.store.isOpen}
            onInteraction={(nextOpenState) => props.store.onInteraction(nextOpenState)}
        >
            <TagAddButtonContentDiv>
                <TagAddForm {...props} />
            </TagAddButtonContentDiv>
        </PopoverButton>
    );
});
